import React from 'react';
import { connect } from 'react-redux';
import PayForTarif from './PayForTarif';
import { setPopUp } from 'actions/environment';
import RequestToConnect from '../RequestToConnect';
import { compose } from 'redux';

const mapStateToProps = (state) => ({
  userId: state.profile.id
});

const mapDispatchToProps = (dispatch) => ({
  closePopup: () => dispatch(setPopUp()),
  showRequestForm: () => dispatch(setPopUp(<RequestToConnect />, { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false }))
});

const mergeProps = (stateProps, dispatchProps, otherProps) => ({
  shopSuccessUrl: process.env.NODE_ENV === 'development' ? 'http://portaldev.nedvx.ru/pay/success' : 'https://nedvex.ru/pay/success',
  shopFailUrl: process.env.NODE_ENV === 'development' ? 'http://portaldev.nedvx.ru/pay/fail' : 'https://nedvex.ru/pay/fail',
  ...stateProps,
  ...dispatchProps,
  ...otherProps
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(PayForTarif);



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarif/PayForTarifContainer.js